<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('用户实名认证.用户信息')">
                <a-input v-model="queryParam.nickName" @pressEnter="handleQuery" :placeholder="$t('用户实名认证.用户信息搜索提示')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('用户实名认证.审核状态')">
                <a-select :placeholder="$t('通用.输入.请选择')+$t('用户实名认证.审核状态')" style="width: 100%" v-model="queryParam.certificationStatus" allowClear>
                  <a-select-option v-for="(item, index) in customDict.UserRealNameStatusEnum" :value="item.type" :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('通用.按钮.查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('通用.按钮.重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="handleExport" v-hasPermi="['userRealName:realName:export']">
          <a-icon type="download" />{{$t('通用.按钮.导出')}}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 详情 -->
      <detail-form ref="detailForm" />
      <!-- 修改 -->
      <create-form ref="createForm" @ok="getList" />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="idCard" slot-scope="text">
          {{ maskIdCard(text) }}
        </span>
        <span slot="certificationStatus" slot-scope="text, record">
          <custom-dict-tag :options="customDict.UserRealNameStatusEnum" :value="record.certificationStatus"/>
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.detailForm.handleDetail(record)" v-hasPermi="['userRealName:realName:query']">
            <a-icon type="eye" />{{$t('用户实名认证.详情')}}
          </a>
          <a-divider type="vertical" />
          <a @click="$refs.createForm.handleUpdate(record)" v-hasPermi="['userRealName:realName:edit']">
            <a-icon type="edit" />{{$t('用户实名认证.修改')}}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageRealName, listRealName, exportRealName } from '@/api/userRealName/realName'
import CustomDictTag from '@/components/DictCustomTag'
import { mapGetters } from 'vuex'
import CreateForm from './modules/CreateForm'
import DetailForm from './modules/DetailForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'UserRealName',
  components: {
    CustomDictTag,
    CreateForm,
    DetailForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      selectedRowKeys: [],
      selectedRows: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        nickName: undefined,
        certificationStatus: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('用户实名认证.用户昵称'),
          dataIndex: 'nickName',
          align: 'center'
        },
        {
          title: this.$t('用户实名认证.手机号'),
          dataIndex: 'mobile',
          align: 'center'
        },
        {
          title: this.$t('用户实名认证.姓名'),
          dataIndex: 'realName',
          align: 'center'
        },
        {
          title: this.$t('用户实名认证.身份证号'),
          dataIndex: 'idCard',
          scopedSlots: { customRender: 'idCard' },
          align: 'center'
        },
        {
          title: this.$t('用户实名认证.审核状态'),
          dataIndex: 'certificationStatus',
          scopedSlots: { customRender: 'certificationStatus' },
          align: 'center'
        },
        {
          title: this.$t('用户实名认证.创建时间'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          align: 'center'
        },
        {
          title: this.$t('通用.文本.操作'),
          dataIndex: 'operation',
          width: '12%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  created () {
    this.getList()
  },
  methods: {
    getTotal (total) {
      return this.$t('通用.文本.共') + total + this.$t('通用.文本.条')
    },
    /** 查询列表 */
    getList () {
      this.loading = true
      pageRealName(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        nickName: undefined,
        certificationStatus: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('通用.文本.是否确认导出'),
        content: this.$t('通用.文本.此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('userRealName/realName/export', that.queryParam, `用户实名认证_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    },
    /** 身份证号脱敏 */
    maskIdCard (idCard) {
      if (!idCard) return '-'
      if (idCard.length <= 8) return idCard
      return idCard.substring(0, 4) + '**********' + idCard.substring(idCard.length - 4)
    }
  }
}
</script>
